import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDay } from "@/lib/format";
import { Btn, Field, Modal } from "@/components/rp";

const todayIso = () => new Date().toLocaleDateString("en-CA");

export const invoiceText = (x) => (x.invoice_number || x.invoice_date
  ? `Fattura${x.invoice_number ? ` n. ${x.invoice_number}` : ""}${x.invoice_date ? ` del ${fmtDay(x.invoice_date)}` : ""}` : "");

export const InvoiceDialog = ({ open, onClose, onConfirm, title, withFile, testid = "invoice-dialog" }) => {
  const [f, setF] = useState({ number: "", date: todayIso() });
  const [file, setFile] = useState(null);
  const [used, setUsed] = useState([]);
  useEffect(() => { if (open) { setF({ number: "", date: todayIso() }); setFile(null); setUsed([]); } }, [open]);
  useEffect(() => {
    const n = f.number.trim();
    if (!n || !f.date) { setUsed([]); return; }
    const t = setTimeout(() => api.get("/amministrazione/invoice-check", { params: { number: n, year: f.date.slice(0, 4) } }).then((r) => setUsed(r.data.used)).catch(() => {}), 350);
    return () => clearTimeout(t);
  }, [f.number, f.date]);
  return (
    <Modal open={open} onOpenChange={(o) => !o && onClose()} title="Segna come fatturato" description={title} testid={testid}>
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="Numero fattura (facoltativo)"><input value={f.number} onChange={(e) => setF({ ...f, number: e.target.value })} className="rp-field" placeholder="Es. 12/2026" data-testid="invoice-number-input" /></Field>
        <Field label="Data fattura"><input type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} className="rp-field" data-testid="invoice-date-input" /></Field>
      </div>
      {used.length > 0 && (
        <p className="mt-3 rounded-xl bg-[#B26A00]/10 p-3 text-sm text-[#B26A00]" data-testid="invoice-duplicate-warning">
          Attenzione: il numero {f.number.trim()} è già usato nel {f.date.slice(0, 4)} per {used.map((u) => `${u.code} · ${u.label}`).join(", ")}.
        </p>
      )}
      {withFile && <div className="mt-3"><Field label="PDF della fattura (facoltativo)"><input type="file" accept=".pdf,image/*" onChange={(e) => setFile(e.target.files?.[0] || null)} className="text-sm" data-testid="invoice-file-input" /></Field></div>}
      <Btn className="mt-4" disabled={!f.date} onClick={() => onConfirm({ invoice_number: f.number.trim() || null, invoice_date: f.date, file })} data-testid="invoice-confirm">Conferma fatturazione</Btn>
    </Modal>
  );
};
